import React, { useState, useRef, useEffect } from 'react';
import { FaMicrophoneAlt, FaVideo, FaMagic } from 'react-icons/fa';
import Form from './Form';
import '../assets/styling/Service.css';

const services = [
  {
    title: 'Înregistrare în studio',
    icon: <FaMicrophoneAlt />,
    desc: (
      <>
        <strong>Tarif standard: 100€/oră (+TVA)</strong>
        <ul className="service-features">
          <li>Studio complet echipat (audio + video)</li>
          <li>Materiale brute livrate prin link securizat (export direct din camere)</li>
        </ul>
      </>
    )
  },
  {
    title: 'Operator de filmare',
    icon: <FaVideo />,
    desc: (
      <>
        <strong>Cost suplimentar: 50€/zi</strong>
        <ul className="service-features">
          <li>Asigură calitate optimă pe toată durata înregistrării</li>
        </ul>
      </>
    )
  },
  {
    title: 'Editare & Post-producție',
    icon: <FaMagic />,
    desc: (
      <>
        <strong>Pachet complet de prelucrare audio + video:</strong>
        <ul className="service-features">
          <li>Montaj & corecție audio</li>
          <li>Grafică (overlays, intro/outro, branding)</li>
          <li>Subtitrări</li>
          <li>Materiale promoționale (clipuri scurte, teasere)</li>
        </ul>
      </>
    )
  }
];

const Service = () => {
  const [active, setActive] = useState(0);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  // Swipe handlers for mobile
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    if (touchStartX.current !== null && touchEndX.current !== null) {
      const diff = touchStartX.current - touchEndX.current;
      if (diff > 50 && active < services.length - 1) setActive(active + 1);
      if (diff < -50 && active > 0) setActive(active - 1);
    }
    touchStartX.current = null;
    touchEndX.current = null;
  };

  // Keyboard arrow navigation for accessibility
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'ArrowLeft' && active > 0) setActive(active - 1);
      if (e.key === 'ArrowRight' && active < services.length - 1) setActive(active + 1);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [active]);

  return (
    <section className="service-section">
      <h2 className="service-title">Serviciile Noastre</h2>
      <p className="service-desc">Oferim soluții digitale complete pentru afacerea ta: de la înregistrare și filmare la editare și post-producție.</p>
      <div
        className="service-cards-wrapper"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {services.map((service, idx) => (
          <div
            className={`service-card${active === idx ? ' active' : ''}`}
            key={service.title}
            style={{
              ...(window.innerWidth > 900
                ? {}
                : {
                    transform: `translateX(calc(${(idx - active) * 100}%))`,
                    zIndex: active === idx ? 2 : 1
                  })
            }}
            tabIndex={0}
            aria-hidden={window.innerWidth <= 900 && active !== idx}
          >
            <div className="service-card-header">
              <h3>{service.title}</h3>
              <span className="service-icon">{service.icon}</span>
            </div>
            <div className="service-desc-content">{service.desc}</div>
          </div>
        ))}
      </div>
      <div className="service-dots mobile-only">
        {services.map((_, idx) => (
          <button
            key={idx}
            className={`dot${active === idx ? ' active' : ''}`}
            onClick={() => setActive(idx)}
            aria-label={`Go to service ${idx + 1}`}
          />
        ))}
      </div>
      
      
    </section>
  );
};

export default Service; 